// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ConsistencyCheckDetails_tableWrapper__vj3L+","deltaHeader":"ConsistencyCheckDetails_deltaHeader__DMmGC","deltaCell":"ConsistencyCheckDetails_deltaCell__Me7mQ"};